export const supportCenterData = {
  categories: [
    {
      id: 1,
      title: "Getting Started",
      description: "Setup guides and basic configuration",
      articles: 12,
    },
    {
      id: 2,
      title: "Calendar & Bookings",
      description: "Manage reservations and availability",
      articles: 8,
    },
    {
      id: 3,
      title: "Smart Lock Access",
      description: "Configure and troubleshoot access codes",
      articles: 6,
    },
    {
      id: 4,
      title: "User Management",
      description: "Add team members and manage permissions",
      articles: 9,
    },
  ],

  tutorials: [
    {
      id: 1,
      title: "Connecting Your Calendar System",
      description: "Learn how to sync Google and Outlook calendars with your workspace",
      duration: "4:25",
      imageUrl: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=300&h=170&fit=crop",
    },
    {
      id: 2,
      title: "Smart Lock Configuration Guide",
      description: "Set up automatic access codes for your guests",
      duration: "7:12",
      imageUrl: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=300&h=170&fit=crop",
    },
    {
      id: 3,
      title: "Creating Custom Booking Forms",
      description: "Customize the information you collect from clients",
      duration: "5:38",
      imageUrl: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=300&h=170&fit=crop",
    },
    {
      id: 4,
      title: "Setting Up Payment Processing",
      description: "Connect payment providers and configure booking policies",
      duration: "9:10",
      imageUrl: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=300&h=170&fit=crop",
    },
  ],

  faqs: [
    {
      id: 1,
      question: "How do I connect my Google Calendar to sync bookings?",
      answer:
        "You can connect your Google Calendar by navigating to the Integrations page in your settings. Click on Connect Google Calendar and follow the on-screen instructions to authorize access. Once connected, your bookings will automatically sync.",
    },
    {
      id: 2,
      question: "Can guests create their own access codes?",
      answer:
        "Currently, guests cannot create their own access codes. Access codes are generated by administrators or property managers through the Smart Lock Access panel to ensure security and proper management.",
    },
    {
      id: 3,
      question: "How do I generate monthly revenue reports?",
      answer:
        "Monthly revenue reports can be generated from the Reports section. Select Revenue Report, specify the month and year, and click Generate. The report will be available for download in PDF or CSV format.",
    },
    {
      id: 4,
      question: "What happens if a guest damages something in my workspace?",
      answer:
        "In case of damage, document the incident with photos and details. Contact the guest to discuss resolution. If you have a security deposit system in place, you may use it according to your terms. For further assistance, you can submit a support ticket detailing the issue.",
    },
    {
      id: 5,
      question: "How can I set up automated notifications for new bookings?",
      answer:
        "Automated notifications can be configured in the Notifications settings. You can choose to receive email or SMS alerts for new bookings, cancellations, and modifications. Customize the triggers and recipients as needed.",
    },
  ],

  supportTickets: [
    {
      id: 1082,
      title: "Calendar integration not syncing with Google Calendar",
      status: "Open",
      tags: ["Integration", "Calendar"],
      createdAt: "2024-01-15T09:45:00Z",
    },
    {
      id: 1079,
      title: "Smart lock access code not working for guests",
      status: "Open",
      tags: ["Smart Lock", "Access"],
      createdAt: "2024-01-14T15:22:00Z",
    },
  ],

  ticketCounts: {
    open: 2,
    pending: 1,
    closed: 3,
  },

  quickResources: [
    {
      id: 1,
      title: "Administrator Guide",
      description: "Complete setup documentation",
    },
    {
      id: 2,
      title: "Guest Access Guide",
      description: "For sharing with clients",
    },
    {
      id: 3,
      title: "API Documentation",
      description: "For custom integrations",
    },
  ],
};
